import React from "react";
import { Link } from "react-router-dom";
import images from "../../utils/imageLoader";
import Seo from "../../components/Seo";
import "../../style/style-pages/service-detail-page.css";

const ServiceDetailPage = ({ service }) => {
    return (
        <main className="service-detail">
            <Seo canonicalPath={service.path} description={service.intro} title={service.title} />
            <section className="service-detail__hero">
                <div className="service-detail__hero-inner container">
                    <div>
                        <Link className="service-detail__back" to="/services">Our Services</Link>
                        <h1>{service.title}</h1>
                        <p>{service.intro}</p>
                        <Link className="service-detail__cta" to="/#contact">Start a project</Link>
                    </div>
                    <img src={images[service.image]} alt="" />
                </div>
            </section>

            <section className="service-detail__content">
                <div className="container">
                    <div className="service-detail__summary">
                        <p>{service.summary}</p>
                    </div>
                    <header className="service-detail__deliverables-heading">
                        <p>WHAT THIS ENGAGEMENT CAN INCLUDE</p>
                        <h2>Clear deliverables for the next decision.</h2>
                    </header>
                    <div className="service-detail__points">
                        {service.points.map((point) => (
                            <article key={point.title}>
                                <h2>{point.title}</h2>
                                <p>{point.body}</p>
                            </article>
                        ))}
                    </div>
                    <section className="service-detail__best-for" aria-labelledby="best-for-title">
                        <div>
                            <p>BEST SOLUTIONS FOR</p>
                            <h2 id="best-for-title">Teams that need a clearer path forward.</h2>
                        </div>
                        <ul>
                            {service.bestFor.map((item) => <li key={item}>{item}</li>)}
                        </ul>
                    </section>
                </div>
            </section>
        </main>
    );
};

export default ServiceDetailPage;
